import {backAdmin} from "../axios";

export const categoriesApi = [
    {url: `${backAdmin}/categories`, name: 'categories.all', method: 'GET'},
    {url: `${backAdmin}/categories/subcategories`, name: 'categories.subcategories', method: 'GET'},
    {url: `${backAdmin}/categories/{id}/status`, name: 'category.update.status', method: 'PUT'},
    {url: `${backAdmin}/categories/{id}`, name: 'category.delete', method: 'DELETE'},
    {url: `${backAdmin}/categories`, name: 'category.create', method: 'POST'},
    {url: `${backAdmin}/categories/{id}`, name: 'category.update', method: 'PUT'},
    {url: `${backAdmin}/categories/{id}/media`, name: 'category.media.delete', method: 'DELETE'},
    {url: `${backAdmin}/categories/{id}/media`, name: 'category.media.update', method: 'POST'},
    {url: `${backAdmin}/categories/{id}/sort`, name: 'category.update.sort', method: 'PUT'},
]